module.exports = __webpack_public_path__ + "static/chocolate_chip_cookies-6df4414cfd0b906ef4ae3998e3187ff0.png";